import { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function EmailVerificationBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      toast.success(data.email_sent ? "Verification email sent!" : "Couldn't send email right now — please try again shortly.");
    } catch {
      toast.error("Failed to resend verification email");
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="email-verification-banner"
      className="flex items-center justify-center gap-2 border-b border-sky-300/40 bg-sky-50 px-4 py-2 text-sm font-medium text-sky-700 dark:bg-sky-950/30 dark:text-sky-300"
    >
      <MailWarning className="h-4 w-4" />
      Please verify your email address to unlock jobs, resume uploads and invites.
      <button onClick={resend} disabled={sending} className="ml-1 underline underline-offset-2" data-testid="resend-verification-btn">
        {sending ? <Loader2 className="inline h-3 w-3 animate-spin" /> : "Resend email"}
      </button>
    </div>
  );
}
